var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "voice-configuration" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "form-container" }, [
      _c("div", { staticClass: "form-layout" }, [
        _c("div", { staticClass: "switches-section" }, [
          _c("h3", { staticClass: "section-title" }, [_vm._v("Genel Ayarlar")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "switch-group" },
            [
              _vm._m(1),
              _vm._v(" "),
              _c("a-switch", {
                attrs: { size: "small" },
                model: {
                  value: _vm.payload.enable,
                  callback: function ($$v) {
                    _vm.$set(_vm.payload, "enable", $$v)
                  },
                  expression: "payload.enable",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "switch-group" },
            [
              _vm._m(2),
              _vm._v(" "),
              _c("a-switch", {
                attrs: { size: "small" },
                model: {
                  value: _vm.payload.metaData.is_register,
                  callback: function ($$v) {
                    _vm.$set(_vm.payload.metaData, "is_register", $$v)
                  },
                  expression: "payload.metaData.is_register",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "switch-group" },
            [
              _vm._m(3),
              _vm._v(" "),
              _c("a-switch", {
                attrs: { size: "small" },
                model: {
                  value: _vm.payload.metaData.force_tcp,
                  callback: function ($$v) {
                    _vm.$set(_vm.payload.metaData, "force_tcp", $$v)
                  },
                  expression: "payload.metaData.force_tcp",
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputs-section" }, [
          _c("div", { staticClass: "inputs-layout" }, [
            _c("div", { staticClass: "input-section" }, [
              _c("h3", { staticClass: "section-title" }, [
                _vm._v("SIP Sunucu Ayarları"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _vm._m(4),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: {
                      placeholder: "örn: sip.example.com",
                      size: "default",
                    },
                    model: {
                      value: _vm.payload.metaData.host,
                      callback: function ($$v) {
                        _vm.$set(_vm.payload.metaData, "host", $$v)
                      },
                      expression: "payload.metaData.host",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _vm._m(5),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: {
                      placeholder: "5060",
                      size: "default",
                      type: "number",
                    },
                    model: {
                      value: _vm.payload.metaData.port,
                      callback: function ($$v) {
                        _vm.$set(_vm.payload.metaData, "port", $$v)
                      },
                      expression: "payload.metaData.port",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-section" }, [
              _c("h3", { staticClass: "section-title" }, [
                _vm._v("Kimlik Doğrulama"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _vm._m(6),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: {
                      placeholder: "Kullanıcı ID'si girin",
                      size: "default",
                    },
                    model: {
                      value: _vm.payload.metaData.user,
                      callback: function ($$v) {
                        _vm.$set(_vm.payload.metaData, "user", $$v)
                      },
                      expression: "payload.metaData.user",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _vm._m(7),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: {
                      placeholder: "Kullanıcı adını girin",
                      size: "default",
                    },
                    model: {
                      value: _vm.payload.metaData.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.payload.metaData, "username", $$v)
                      },
                      expression: "payload.metaData.username",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _vm._m(8),
                  _vm._v(" "),
                  _c("a-input", {
                    attrs: { placeholder: "Secret Key girin", size: "default" },
                    model: {
                      value: _vm.payload.metaData.secret_key,
                      callback: function ($$v) {
                        _vm.$set(_vm.payload.metaData, "secret_key", $$v)
                      },
                      expression: "payload.metaData.secret_key",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-footer" }, [
      _c(
        "div",
        { staticClass: "footer-actions" },
        [
          _c(
            "a-button",
            {
              staticClass: "cancel-btn",
              attrs: { size: "large" },
              on: { click: _vm.handleCancel },
            },
            [
              _c("a-icon", { attrs: { type: "close" } }),
              _vm._v("\n                İptal\n            "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-button",
            {
              staticClass: "save-btn",
              attrs: { size: "large", type: "primary", loading: _vm.loading },
              on: { click: _vm.handleSave },
            },
            [
              _c("a-icon", { attrs: { type: "save" } }),
              _vm._v("\n                Kaydet\n            "),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "header-content" }, [
        _c("h2", { staticClass: "title" }, [_vm._v("Ses Ayarları")]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle" }, [
          _vm._v("WhatsApp Business sesli arama ayarlarını yapılandırın"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "switch-label" }, [
      _c("span", { staticClass: "label-text" }, [_vm._v("Ses Aktif")]),
      _vm._v(" "),
      _c("span", { staticClass: "label-description" }, [
        _vm._v("Sesli arama özelliğini etkinleştirin"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "switch-label" }, [
      _c("span", { staticClass: "label-text" }, [_vm._v("Kayıt")]),
      _vm._v(" "),
      _c("span", { staticClass: "label-description" }, [
        _vm._v("SIP kaydını etkinleştirin"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "switch-label" }, [
      _c("span", { staticClass: "label-text" }, [_vm._v("Force TCP")]),
      _vm._v(" "),
      _c("span", { staticClass: "label-description" }, [
        _vm._v("TCP protokolünü zorla kullan"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "input-label" }, [
      _c("span", { staticClass: "label-text" }, [
        _vm._v("Host "),
        _c("span", { staticClass: "required" }, [_vm._v("*")]),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "label-description" }, [
        _vm._v("SIP sunucu adresi"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "input-label" }, [
      _c("span", { staticClass: "label-text" }, [_vm._v("Port")]),
      _vm._v(" "),
      _c("span", { staticClass: "label-description" }, [
        _vm._v("SIP sunucu portu"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "input-label" }, [
      _c("span", { staticClass: "label-text" }, [_vm._v("Kullanıcı")]),
      _vm._v(" "),
      _c("span", { staticClass: "label-description" }, [
        _vm._v("SIP kullanıcı kimliği"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "input-label" }, [
      _c("span", { staticClass: "label-text" }, [_vm._v("Kullanıcı Adı")]),
      _vm._v(" "),
      _c("span", { staticClass: "label-description" }, [
        _vm._v("SIP kullanıcı adı"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { staticClass: "input-label" }, [
      _c("span", { staticClass: "label-text" }, [_vm._v("Secret Key")]),
      _vm._v(" "),
      _c("span", { staticClass: "label-description" }, [
        _vm._v("SIP Secret Key"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }